module.exports = __webpack_public_path__ + "img/xinyang.70dd978e.png";